import { lazy } from 'react';

import { IRoute } from '@common/Routing/types';
import { getLazyComponent } from '@utils/utils';
import { Path } from '@const/paths';

export { default as EnvelopesHead } from './components/EnvelopesHead/EnvelopesHead'
export { default as EnvelopesTable } from './components/EnvelopesTable/EnvelopesTable'
export { default as EnvelopeItem } from './components/EnvelopesTable/EnvelopeItem/EnvelopeItem'

const Envelopes = lazy(() => import('./components/Envelopes'))
const EnvelopesCard = lazy(() => import('./components/EnvelopeCard/EnvelopeCard'))
const NewEnvelope = lazy(() => import('./components/NewEnvelope'))
const BoxSettings = lazy(() => import('../boxes/components/BusinessBoxSettings').then(module=>({default:module.BusinessBoxSettings})));
const BoxUsers = lazy(() => import('../boxes/components/BusinessBoxUsers').then(module=>({default:module.BusinessBoxUsers})));
const BoxSubdivisions = lazy(() => import('../boxes/components/BusinessBoxSubdivisions').then(module=>({default:module.BusinessBoxSubdivisions})));
const BoxContactDirectory = lazy(() => import('../boxes/components/BusinessBoxContactDirectory/index').then(module=>({default:module.BusinessBoxContactDirectory})));
const BoxCustomFields = lazy(() => import('../boxes/components/BusinessBoxCustomFields').then(module=>({default:module.BusinessBoxCustomFields})));
const BoxLabels = lazy(() => import('../boxes/components/BusinessBoxLabels/index').then(module=>({default:module.BusinessBoxLabels})));
const BoxEnvelopeTemplates = lazy(() => import('../boxes/components/BusinessBoxEnvelopeTemplates').then(module=>({default:module.BusinessBoxEnvelopeTemplates})));
const BoxEnvelopeTemplateEditor = lazy(() => import('../boxes/components/BusinessBoxEnvelopeTemplateEditor').then(module=>({default:module.BusinessBoxEnvelopeTemplateEditor})));

export const routesEnvelope: IRoute[] = [
  {
    element: getLazyComponent(Envelopes),
    name: 'envelopes/fast-access',
    path: Path.ENVELOPES_FAST_ACCESS
  },
  {
    element: getLazyComponent(Envelopes),
    name: 'envelopes/box-oquid',
    path: Path.ENVELOPES_BOX_OGUID
  },
  {
    element: getLazyComponent(BoxSettings),
    name: 'envelopes/box-settings',
    path: Path.ENVELOPES_BOX_SETTINGS
  },
  {
    element: getLazyComponent(BoxUsers),
    name: 'envelopes/box-users',
    path: Path.ENVELOPES_BOX_USERS
  },
  {
    element: getLazyComponent(BoxUsers),
    name: 'envelopes/box-invites',
    path: Path.ENVELOPES_BOX_INVITES
  },
  {
    element: getLazyComponent(BoxSubdivisions),
    name: 'envelopes/box-subdivisions',
    path: Path.ENVELOPES_BOX_SUBDIVISIONS
  },
  {
    element: getLazyComponent(BoxContactDirectory),
    name: 'envelopes/box-contact-directory',
    path: Path.ENVELOPES_BOX_CONTACT_DIRECTORY
  },
  {
    element: getLazyComponent(BoxCustomFields),
    name: 'envelopes/box-custom-fields',
    path: Path.ENVELOPES_BOX_CUSTOM_FIELDS
  },
  {
    element: getLazyComponent(BoxLabels),
    name: 'envelopes/box-labels',
    path: Path.ENVELOPES_BOX_LABELS
  },
  {
    element: getLazyComponent(BoxEnvelopeTemplates),
    name: 'envelopes/box-envelope-templates',
    path: Path.ENVELOPES_BOX_ENVELOPE_TEMPLATES
  },
  {
    element: getLazyComponent(BoxEnvelopeTemplateEditor),
    name: 'envelopes/box-envelope-template-add',
    path: Path.ENVELOPES_BOX_ENVELOPE_TEMPLATE_ADD
  },
  {
    element: getLazyComponent(BoxEnvelopeTemplateEditor),
    name: 'envelopes/box-envelope-template-edit',
    path: Path.ENVELOPES_BOX_ENVELOPE_TEMPLATE_EDIT
  },
  {
    element: getLazyComponent(Envelopes),
    name: 'envelopes/filter',
    path: Path.ENVELOPES_FILTER
  },
  {
    element: getLazyComponent(EnvelopesCard),
    name: 'envelope',
    path: Path.ENVELOPE
  },
  {
    element: getLazyComponent(EnvelopesCard),
    name: 'envelope/business',
    path: Path.ENVELOPE_BUSINESS
  },
  {
    element: getLazyComponent(NewEnvelope),
    name: 'NewEnvelope',
    path: Path.ENVELOPE_NEW
  }
]
